import React from 'react';

const Duplicate = ({ size = 16, color = 'gray' }) => (
  <svg
    width={size}
    height={(size * 18) / 24}
    viewBox="0 0 24 18"
    fill="none"
    stroke="none"
    strokeWidth="2"
  >
    <g transform="translate(-678.000000, -2727.000000)">
      <g transform="translate(100.000000, 2626.000000)">
        <g transform="translate(578.000000, 98.000000)">
          <g transform="translate(0.000000, 0.000000)">
            <polygon points="0 0 24 0 24 24 0 24" />
            <path
              d="M15,8 C14.45,8 14,8.45 14,9 L14,11 L12,11 C11.45,11 11,11.45 11,12 C11,12.55 11.45,13 12,13 L14,13 L14,15 C14,15.55 14.45,16 15,16 C15.55,16 16,15.55 16,15 L16,13 L18,13 C18.55,13 19,12.55 19,12 C19,11.45 18.55,11 18,11 L16,11 L16,9 C16,8.45 15.55,8 15,8 Z M2,12 C2,9.42 3.4,7.17 5.48,5.96 C5.8,5.77 6.01,5.45 6.01,5.08 C6.01,4.31 5.17,3.83 4.5,4.22 C1.82,5.78 0,8.68 0,12 C0,15.32 1.82,18.22 4.5,19.78 C5.17,20.17 6.01,19.69 6.01,18.92 C6.01,18.55 5.8,18.23 5.48,18.04 C3.4,16.83 2,14.58 2,12 Z M15,3 C10.04,3 6,7.04 6,12 C6,16.96 10.04,21 15,21 C19.96,21 24,16.96 24,12 C24,7.04 19.96,3 15,3 Z M15,19 C11.14,19 8,15.86 8,12 C8,8.14 11.14,5 15,5 C18.86,5 22,8.14 22,12 C22,15.86 18.86,19 15,19 Z"
              fill={color}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Duplicate;
